<template>
  <div class="kanban">
    <img style="width: 100%;" src="./22.jpg" alt="" />  
  </div>
</template>
<style scoped>
.son {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  top: 36px;
  right: 25px;
  cursor: pointer;
}

.kanban {
  width: 100%;
  padding: 0 !important;
  position: relative;
}
.xingqi{
  margin: 0 10px;
  font-size: 17px; 
    font-weight: bold;
}
.my-timer{
  position: absolute;
    top: 42px;
    color: #fff;
    display: flex;
    left: 28px;
    background: #000;
    font-size: 17px;
    padding: 10px;
    font-weight: bold;
    align-items: center;
}

#my_iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
  background: #333;
  margin: 0px;
}

/*body {*/
/*    overflow: hidden;*/
/*    margin: 0px;*/
/*}*/

.left {
  position: absolute;
  z-index: 2;
  background-color: #000;
  padding: 1em;
  width: 400px;
}

#layer {
  width: 1px;
  height: 1px;

  z-index: 99;
  position: absolute;
  color: #fff;
}

#text {
  width: 100px;
  height: 100px;
  background: #00000066;
  position: relative;
  top: -120px;
  left: -50px;
  border: 2px solid #111;
  border-radius: 5px;
  padding: 0.5em;
}
</style>
<script>
export default {
  data() {
    return {
      timerNull:'',
      timerYMD:'',
      timerWeek:'',
      timerHMS:'',
      fullscreen: false,
      url: require("@/assets/airportTopMenu/" +
        this.$store.menuStore.state.nowMenu.memo +
        ".png"),
    };
  },
  beforeDestroy(){
         // 停止定时器
    clearInterval(this.timerNull);
    },
  computed: {
    memo() {
      return this.$store.menuStore.state.nowMenu.memo;
    },
  },
  watch: {
    memo(nv, ov) {
      this.url = require("@/assets/airportTopMenu/" + nv + ".png");
    },
  },
  mounted() {
    this.timerNull = setInterval(() => {
        // 获取当前日期
        const date = new Date();

        // 获取年份(4位,如2022)
        const year = date.getFullYear();

        // 获取月份(0-11,所以获取月份要加1)
        const month = date.getMonth() + 1;

        // 获取日期
        const day = date.getDate();

        // 获取周几(0-6,0表示周日)
        const week = date.getDay();

        // 24小时制时间
        const hours = date.getHours();

        // 分钟
        const minutes = date.getMinutes();

        // 秒
        const seconds = date.getSeconds();
        this.timerYMD = year + "年" + month + "月" + day + "日";
        this.timerWeek =
          "星期" + ["日", "一", "二", "三", "四", "五", "六"][week];
        this.timerHMS =
          (hours > 10 ? hours : "0" + hours) +
          ":" +
          (minutes > 10 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 10 ? seconds : "0" + seconds);
      }, 1000);
    // console.log(this.$store.menuStore.state.nowMenu.memo,22212);
  },
  methods: {
    // 全屏事件
    handleFullScreen() {
      // 此处可根据获取节点进行区域全屏事件
      let element = document.getElementsByClassName("kanban")[0];
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
